<template>
<div>
   <div class="meter-list-graph-item " v-if="meter.loaded">
                                <font color="#00AF8E">{{meter.name}} {{meter.id}} {{meter.unit}} </font>
								   	<span  @click=AddRemoveMeterId>x</span>
                            </div>
                            <div class="meter-list-graph-item " v-else>
					
                                {{meter.name}} {{meter.id}} {{meter.unit}}
									<span  @click=AddRemoveMeterId>x</span>
                            </div>

	</div>
</template>

<script>
export default {
  name: 'MeterListItem',
 	props: ['meter'],
	data() {
		return {
			loading: false,
		}
	},
	computed: {
        meterSelected(){
             return (this.$store.getters.meterDataIdNameArray.some(meter=>meter.id == this.meter.id)); //if the id is in meterDataIdNameArray then meterSelected is true
        }
	},
	methods: {
        AddRemoveMeterId(){
            let meterIdStripped = this.meter.id;
            if (this.meterSelected===false){
            let meterDataIdArray = this.$store.getters.meterDataIdArray;
            let meterDataIdNameArray = this.$store.getters.meterDataIdNameArray;
                meterDataIdArray.push(meterIdStripped); //expecting formaat of NodeId_-meterId
                  meterDataIdNameArray.push({id: meterIdStripped, name: this.meter.name, loaded:false, unit: ''}); 
                  this.$store.commit('changemeterDataIdArray', meterDataIdArray);
                  this.$store.commit('changemeterDataIdNameArray', meterDataIdNameArray);

                    //clear up memory
                  meterDataIdNameArray = null
                  meterDataIdArray= null
                  meterIdStripped=null
                 } else { //if false then was true before when clicked on
                 //remove the deselected meters from the array
				 
				
                let meterDataIdArray = this.$store.getters.meterDataIdArray;
				let meterDataIdNameArray = this.$store.getters.meterDataIdNameArray;
                meterDataIdArray.splice(meterDataIdArray.indexOf(meterIdStripped),1);
                meterDataIdNameArray.splice(meterDataIdNameArray.findIndex(el => el.id == meterIdStripped), 1);
                      this.$store.commit('changemeterDataIdArray', meterDataIdArray);
                  this.$store.commit('changemeterDataIdNameArray', meterDataIdNameArray);

                        //clear up memory
                  meterDataIdNameArray = null
                  meterDataIdArray= null
		
			this.$parent.meterData = this.$parent.meterData.filter(item => item.id != this.meter.id)
//let indexToRemove = this.$parent.meterData.findIndex(item => item.id == this.meter.id);

//this.$parent.meterData.splice(indexToRemove, 1)
	
	  this.$parent.regraphData()
	  
                 }
        }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
      .meter-list-graph-item {
        font-size:0.8em;
        }
</style>

